import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import PortfolioTable from "components/asset-management/portfolios/portfolio-table"
import { Errors } from "components/asset-management/errors"
import { WithTip } from 'components/tooltip/with-tip'
// Data
import api_match from "data/interface/api"
import assetListService, { Asset } from "data/asset-list"
import portfolioService, { Portfolio } from "data/portfolio"
import userGroupService, { UserGroup } from "data/user-groups"
import importService from "data/import"
import { alphanum } from "components/table/lib/sort"
import validationService from 'data/validate'
import { ContextRow } from './portfolio-table'
import toggles from "feature-toggles"
//Styles
import { Portfolio_s } from "components/asset-management/portfolios/portfolio-styles"
import { AddIcon } from "images/icons/tools"

const PortfolioComponent: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<Portfolio[]>([])
  const [assetData, setAssetData] = useState<Asset[]>([])
  const [userGroups, setUserGroups] = useState<UserGroup[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);

  const tableId = "portfolio-table"

  useEffect(() => {
    validationService.validate('portfolio')
  },[])

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const portfolioSubscription = portfolioService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const assetListSubscription = assetListService.stream().subscribe(data => {
      api_match(
        data,
        init  => setAssetData(init.value),
        ok    => {
          setAssetData(ok.value)
        },
        err   => {
          setAssetData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const userGroupSubscription = userGroupService.stream().subscribe(data => {
      let ug = data['groups'].map(group => { return group });
      setUserGroups(ug);
    })

    assetListService.fetchAssets()
    portfolioService.fetchPortfolios()
    userGroupService.fetchUserGroups()

    return function cleanup() {
      assetListSubscription.unsubscribe()
      portfolioSubscription.unsubscribe()
      userGroupSubscription.unsubscribe()
    }
  }, [initSort])

  const Add = () => {
    return (
      <a onClick={() => portfolioService.create()}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'portfolioid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected ? selected : data

  return (
    <Portfolio_s>
      <Toolbar>
        <Add />
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
        <ImportIcon />
        <ExportIcon template="area" />
        <Errors />
      </Toolbar>
      { showImport && <Import /> }
      { data && assetData && !showImport && <PortfolioTable tableId={tableId} data={_data} assets={assetData} userGroups={userGroups} selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}} /> }
    </Portfolio_s>
  )
}

export default PortfolioComponent
